import { render, staticRenderFns } from "./CompanyLog.vue?vue&type=template&id=be3121da&scoped=true"
import script from "./CompanyLog.vue?vue&type=script&lang=js"
export * from "./CompanyLog.vue?vue&type=script&lang=js"
import style0 from "./CompanyLog.vue?vue&type=style&index=0&id=be3121da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3121da",
  null
  
)

export default component.exports